import {FormControl} from '@angular/forms';
import {Observable} from 'rxjs/Observable';


export class CustomValidators {

  public static linkedEntity(control: FormControl): Promise<any> | Observable<any> | any {
    const value = control.value;
    if (control.value === '') {
        return false;
    }
    if (value !== null) {
      if (value.reference === undefined) {
        return { invalidLinkedEntity: true };
      }
    }
  }

}



// WEBPACK FOOTER //
// C:/Users/DENISE/Documents/IT4U/web-callcenter/src/app/shared/validators/custom.validators.ts